// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; 

const firebaseConfig = {
  apiKey: "AIzaSyDQZR0IZliZOtaGwxWArVBK0J-8qNnA680",
  authDomain: "treatwalk-8cf0b.firebaseapp.com",
  projectId: "treatwalk-8cf0b",
  storageBucket: "treatwalk-8cf0b.firebasestorage.app",
  messagingSenderId: "87469857302",
  appId: "1:87469857302:web:c158bb2fd091eddc867337",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getFirestore(app);

export { database };
